import { FC } from 'react';

import { PageMetadata } from '@/shared';

const Metadata: FC = () => (
    <PageMetadata context='Search' description='Search workspace resources.' segments={['Workspace']} />
);

export default Metadata;
